import { Card } from "antd";

import { Followup } from "components/lists/followups/followup";
import { styles } from "./styles";

export const NextFollowup = (props) => {
  const { followup } = props;

  if (!followup) {
    return null;
  }

  return (
    <div style={styles.infoCard.container}>
      <strong style={styles.infoCard.title}>Next Followup</strong>
      <Card style={styles.infoCard.body}>
        <Followup hideContact followup={followup} />
      </Card>
    </div>
  );
};
